import { useQuery, QueryResult, QueryHookOptions } from '@apollo/client'

import { getCards } from '../queries'

const useCards = (variables?: QueryHookOptions): QueryResult<any> =>
  useQuery(getCards, variables)

export default useCards
